import { Controller } from "@hotwired/stimulus"

// Stands in for the input's autofocus attribute (#3540), which cannot see
// the pointer: focus only the empty page, and never on a touch device, where
// it raises the keyboard over the page. Gated on coarse, not on fine: a
// headless Chrome with no pointing device answers `pointer: none` (the
// Actions runner, #3560) and must still focus.
export default class extends Controller {
  static targets = ["input"]
  static values = { empty: Boolean }

  connect() {
    if (this.emptyValue && !window.matchMedia("(pointer: coarse)").matches) {
      this.inputTarget.focus()
    }
  }
}
